export default __webpack_public_path__ + "static/media/eye-close.62083038.svg";